//Legacy control. Should not be used
class MxSearchControlCtrl {
	static $inject = [];
	constructor() {
		console.warn('Search Control is a legacy control. Should be replace with Global Search Manager');
	}
}

angular.module('mx.SolutionBuilderAgent').component('mxSearchControl', {
	name: 'mxSearchControl',
	template: '<mx-global-search-manager data-navigation-items="vm.navigationItems"></mx-global-search-manager>',
	controller: MxSearchControlCtrl,
	controllerAs: 'vm',
	bindings: {
		navigationItems: '<',
	},
});
